import { useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

export function useTooltip() {
  useEffect(() => {
    // No need to call rebuild as react-tooltip handles this automatically
  }, []);

  return {
    tooltip: (id: string, content: string) => ({
      'data-tooltip-id': `tooltip-${id}`,
      'data-tooltip-content': content,
      'data-tooltip-place': 'top' as const,
      'data-tooltip-delay-show': 100,
    }),
  };
}